import axios from '@/utils/request.js'

export const cylinderAdd = (params) => {
  // 钢瓶录入
  return axios.post('/goods/gas/cylinder/add', params)
}

export const cylinderPreAdd = (params) => {
  // 钢瓶录入下拉选
  return axios.post('/goods/gas/cylinder/preAdd', params)
}

export const cylinderPage = (params) => {
  // 查询钢瓶
  return axios.post('/goods/gas/cylinder/page', params)
}
export const cylinderExitList = (params) => {
  // 查询钢瓶
  return axios.post('/goods/gas/cylinder/exitList', params)
}
export const getCylinderListByDept = (params) => {
  // 查询钢瓶2
  return axios.post('/goods/gas/cylinder/getCylinderListByDept', params)
}
export const cylinderSummaryList = (params) => {
  // 根据部门ID分组查询钢瓶汇总信息
  return axios.post('/goods/gas/cylinder/summary/list', params)
}

export const cylinderSummaryDetail = (params) => {
  // 根据部门ID查询钢瓶汇总明细
  return axios.post('/goods/gas/cylinder/summary/detail', params)
}

export const inflation = (params) => {
  // 充装
  return axios.post('/goods/bGlmCylinderCurrentStatus/inflation', params)
}

export const warehousing = (params) => {
  // 入库
  return axios.post('/goods/bGlmCylinderCurrentStatus/warehousing', params)
}

export const payGoods = (params) => {
  // 付货
  return axios.post('/goods/bGlmCylinderCurrentStatus/payGoods', params)
}

export const groupListByCompanyId = (params) => {
  // 根据公司ID获取销售组列表
  return axios.post('/goods/gas/department/getGroupListByCompanyId', params)
}

export const getInventoryList = (params) => {
  // 出库库存列表
  return axios.post('/goods/gas/inventory/list', params)
}
export const departmentList = (params) => {
  // 收货部门列表
  return axios.post('/goods/gas/inventory/department/list', params)
}

export const inventoryScan = (params) => {
  // 扫码添加
  console.log(params)
  return axios.post('/goods/gas/inventory/scan', params)
}
export const inventoryFillscan = (params) => {
  // 扫码添加
  console.log(params)
  return axios.post('/goods/gas/inventory/fillscan', params)
}

export const inventoryPay = (params) => {
  // 扫码/直接付货
  return axios.post('/goods/gas/inventory/pay', params)
}

export const payList = (params) => {
  // 直接付货查询
  return axios.post('/goods/gas/inventory/direct/pay/list', params)
}

export const cylinderRelation = (params) => {
  // 扫码关联
  return axios.post('/goods/gas/cylinderRelation/ref', params)
}
export const cylinderReRef = (params) => {
  // 重新关联
  return axios.post('/goods/gas/cylinder/cylinderReRef', params)
}
export const cylinderRelationOpen = (params) => {
  // 钢瓶启用
  return axios.post('/goods/gas/cylinderRelation/open', params)
}

export const cylinderRelationRemoveRef = (params) => {
  // 钢瓶退出
  return axios.post('/goods/gas/cylinderRelation/removeRefBatch', params)
}
export const getFillGoods = (params) => {
  // 冲装商品
  return axios.post('/goods/gas/cylinder/fill/getFillGoods', params)
}
export const cylinderDetail = (id) => {
  // 钢瓶录入
  return axios.post(`/goods/gas/cylinder/getDetailByCode/${id}`)
}
export const addFillApplyCheckPre = (params) => {
  // 检查
  return axios.post('/goods/gas/cylinder/summary/addFillApplyCheckPre', params)
}
export const addFillApplyCheckPreSuper = (params) => {
  // 检查
  return axios.post('/goods/gas/cylinder/summary/addFillApplyCheckPreSuper', params)
}
export const addFillApplyCheckAfter = (params) => {
  // 检查
  return axios.post(
    '/goods/gas/cylinder/summary/addFillApplyCheckAfter',
    params
  )
}
export const getDetailByCode = (sendUnit, gsCode) => {
  return axios.post(`/goods/gas/cylinder/getDetailByCode/${sendUnit}/${gsCode}`)
}
export const addExt = (params) => {
  return axios.post('/goods/gas/cylinder/addExtOut', params)
}
export const getBatchList = (params) => {
  return axios.post('/goods/gas/cylinder/getBatchList', params)
}
export const getCylinderListByBatchNo = (params) => {
  return axios.post('/goods/gas/cylinder/getCylinderListByBatchNo', params)
}
export const getEmpList = (params) => {
  return axios.post('/goods/gas/cylinder/getEmpList', params)
}
export const allocCylinderList = (params) => {
  return axios.post('/goods/gas/cylinder/allocCylinderList', params)
}
export const getBatchNoBySendUnit = (params) => {
  return axios.post('/goods/gas/cylinder/getBatchNoBySendUnit', params)
}
export const addOutCylinderCheck = (params) => {
  return axios.post('/goods/gas/cylinder/addOutCylinderCheck', params)
}
export const getUserCheckListForApp = (params) => {
  return axios.post(
    '/goods/gas/bGlmCylinderCheck/getUserCheckListForApp',
    params
  )
}
export const getCheckInfoListForApp = (params) => {
  return axios.post(
    '/goods/gas/bGlmCylinderCheck/getCheckInfoListForApp',
    params
  )
}
export const getCheckCylinderListByUserIdForApp = (params) => {
  return axios.post(
    '/goods/gas/bGlmCylinderCheck/getCheckCylinderListByUserIdForApp',
    params
  )
}
export const getCyEthyneCheckInfoMess = (params) => {
  return axios.post(
    '/goods/gas/bGlmCylinderCheck/getCyEthyneCheckInfoMess',
    params
  )
}
export const getCyCheckInfoMess = (params) => {
  return axios.post('/goods/gas/bGlmCylinderCheck/getCyCheckInfoMess', params)
}
export const fromOption = (params) => {
  return axios.post('/goods/gas/bGlmCylinderCheck/fromOption', params)
}

export const updateCylinderCheckEthyneResult = (params) => {
  return axios.post(
    '/goods/gas/bGlmCylinderCheck/updateCylinderCheckEthyneResult',
    params
  )
}
export const updateCylinderCheckResult = (params) => {
  return axios.post(
    '/goods/gas/bGlmCylinderCheck/updateCylinderCheckResult ',
    params
  )
}
